import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { useNavigate, useParams } from 'react-router';
import { useRemoveUserFromSpace } from 'modules/security/user-providers/hooks/useRemoveUserFromSpace';

type ProviderUserRowActionsProps = {
  rowId: string;
};

const ProviderUserRowActions = ({ rowId }: ProviderUserRowActionsProps) => {
  const { id: spaceId = '' } = useParams();
  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isPending, error } = useRemoveUserFromSpace(rowId, spaceId, onClose);
  const navigate = useNavigate();

  const goTo = () => {
    navigate(`/security/providers-users/user/${rowId}/general`);
  };

  return (
    <Stack direction='row' spacing={1}>
      <EditRowActions onClick={goTo} />
      <DeleteRowAction
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        error={error}
        isLoading={isPending}
        onDelete={mutate}
      />
    </Stack>
  );
};

export default memo(ProviderUserRowActions);
